import React, { useState } from "react";
import styled from "styled-components";

import DomeHeader from "../components/DomeHeader";
import Button from "../components/Button";
import RatingStars from "../components/RatingStars";
import { Header2, DomeText, ProximaNova } from "../components/typography";
import Review from "../components/Review";
import { Colors } from "../components/styles/Colors";

const Wrapper = styled.div`
  padding: 64px 32px;
  background: ${Colors.cream3};

  text-align: center;

  ${Header2} {
    color: ${Colors.grey};
    margin: 24px 0 32px;
  }

  > div:nth-of-type(2) {
    margin: 12px 0;
    justify-content: center;
  }
`;

const SmallText = styled(DomeText)`
  font-size: 12px;
  font-weight: 400;
`;

const ShowMore = styled.div`
  button,
  p {
    font-family: ${ProximaNova};
    font-size: 14px;
  }

  button {
    appearance: none;
    border: 0;
    outline: 0;
    border-bottom: 1px solid ${Colors.medGrey};
    color: ${Colors.darkGrey};
    margin: 0;
    padding: 0;
    cursor: pointer;
  }

  p {
    color: ${Colors.medGrey};
  }
`;

export default function ProductReviews({ product }) {
  const increment = 5;
  const [total, setTotal] = useState(increment);
  const [moreVisible, setMoreVisible] = useState(true);
  let reviews = [];
  let rating = 0;

  if (product.__typename === "ContentfulProductSet") {
    // const reviewItems = product.variants.reduce((accumulator, obj) => [...accumulator, ...obj.product?.reviews], [])
    // reviews = reviewItems
    // const ratingScores = product.variants.map(prod => prod.product?.rating.score)
    // rating = ratingScores.reduce((a, b) => a + b) / ratingScores.length
  } else {
    reviews = product?.reviews;
    rating = product?.rating?.score;
  }

  const count = reviews?.length;
  const sortedReviews = reviews?.sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt);
  });
  let visibleReviews = sortedReviews?.slice(0, total) || [];
  const limit = count - increment;

  function showMore() {
    if (total > limit) {
      setTotal(count);
      setMoreVisible(false);
    } else {
      setTotal(total + increment);
    }
  }

  return (
    <Wrapper id="product-reviews">
      <DomeHeader text="Reviews" centered />
      <Header2>Who Likes it?</Header2>
      {/* <Button>Write a Review</Button> */}
      <SmallText>Average Rating</SmallText>
      <RatingStars count={count} score={rating} />
      {visibleReviews?.map((review) => (
        <Review review={review} />
      ))}
      <ShowMore>
        {moreVisible && <button onClick={showMore}>Show More</button>}
        <p>
          1–{!moreVisible ? count : total} of {count} Reviews
        </p>
      </ShowMore>
    </Wrapper>
  );
}
